
export default {
  name: 'AtomTrashButton'
}
